// start:ng42.barrel
export * from './cancel-res.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-res/cancel-res/index.ts